module.exports = __webpack_public_path__ + "static/img/articlehub.b400660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlehub.jpg
// module id = dqJ2
// module chunks = 1